import React, { useEffect, useState, useCallback } from "react";
import { NumericFormat } from 'react-number-format';
import Moment from 'react-moment';
import moment from "moment-timezone";
import { Container, Form, Row, Col, Table, InputGroup, Button, Navbar } from "react-bootstrap";
import Header from '../../Layout/Header'
import { FaSearch, FaPlus } from "react-icons/fa";
import { Link } from "react-router-dom";
import Loader from "react-js-loader";
import { Helmet } from "react-helmet";
import { BadgeStatus, getEndpointUrl } from "../../Utils/Common";
import { useNavigate, useParams } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import 'react-toastify/dist/ReactToastify.css';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { alertService } from "../../Utils/AlertService/alert.service";
import BsAlert from "../../Utils/BsAlert";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ModalSelectOffer from "../Offer/ModalSelectOffer";
import Error404 from "../Error404";
import { HiArrowLeft } from 'react-icons/hi';
import { useMediaQuery } from 'react-responsive';
import SidebarMenu from "../../Layout/SidebarMenu";

const UpdateInvoice = () => {
    const [error404, setError404] = useState(false);
    const [isLoading, setLoading] = useState(true);
    const [saveLoading, setSaveLoading] = useState(false);
    const [options, setOptions] = useState({
        autoClose: true,
        keepAfterRouteChange: false
    });

    const navigate = useNavigate();

    const [sidebarVisible, setSidebarVisible] = useState(false);

    const isMobile = useMediaQuery({ query: '(max-width: 600px)' });
    const isTabletOrLaptop = useMediaQuery({ query: '(min-width: 600px)' });

    const [accesToken] = useState(
        JSON.parse(localStorage.getItem('credentials')) || []
    );

    const [userLogin] = useState(
        JSON.parse(localStorage.getItem('knowLogin')) || []
    );

    const params = useParams();

    const [offer, setOffer] = useState([]);

    const [modalSelectOffer, setModalSelectOffer] = useState(false);

    const [invoiceDate, setInvoiceDate] = useState(new Date());
    const [doeDate, setDoeDate] = useState(new Date());

    const fetchDataInvoice = useCallback(async (invoice_id) => {
        setLoading(true);
        fetch(getEndpointUrl() + `/invoice/${invoice_id !== undefined ? invoice_id : 0}`, {
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            if (json.status === 'ok') {
                fetchDataOffer(json.results.offer_id);

                setInvoiceDate(new Date(json.results.invoiceDate));
                setDoeDate(new Date(json.results.doeDate));

                let defaultValues = {};
                defaultValues.date = new Date(json.results.invoiceDate);
                defaultValues.doeDate = new Date(json.results.doeDate);
                defaultValues.customerName = json.results.customerName;
                defaultValues.amount = json.results.amount;
                defaultValues.description = json.results.noteDescription;
                reset({ ...defaultValues });
            } else {
                setError404(true);
            }

            setLoading(false);
        });
    }, []);

    const fetchDataOffer = useCallback(async (offer_id) => {
        setLoading(true);
        fetch(getEndpointUrl() + `/offer/${offer_id !== undefined ? offer_id : 0}`, {
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            if (json.status === 'ok') {
                setOffer(json.results);

                let defaultValues = {};
                defaultValues.offer_id = json.results.id;
                defaultValues.date = new Date(invoiceDate);
                defaultValues.doeDate = new Date(doeDate);
                defaultValues.customerName = json.results.customerName;
                defaultValues.amount = json.results.price;
                defaultValues.description = json.results.description;
                reset({ ...defaultValues });
            }

            setLoading(false);
        });
    }, []);

    const validationSchema = Yup.object().shape({
        date: Yup.string().required('Field harus diisi'),
        doeDate: Yup.string().required('Field harus diisi'),
        offer_id: Yup.number().nullable().typeError("Field berupa angka").required('Field harus diisi'),
        amount: Yup.number().nullable().typeError("Field berupa angka").required('Field harus diisi'),
        description: Yup.string().required('Field harus diisi'),
        customerName: Yup.string().required('Field harus diisi')
    });

    const { register, handleSubmit, reset, control, formState } = useForm({
        resolver: yupResolver(validationSchema)
    });

    const { errors } = formState;

    useEffect(() => {
        fetchDataInvoice(params.invoice_id);
    }, [params, fetchDataInvoice, reset]);

    const onSubmit = data => {

        setSaveLoading(true);

        fetch(getEndpointUrl() + `/invoice/${params.invoice_id}`, {
            method: "PUT",
            body: new URLSearchParams({
                offer_id: data.offer_id,
                customer_id: offer.customer_id,
                customerName: data.customerName,
                date: moment(data.date).format('YYYY-MM-DD'),
                doeDate: moment(data.doeDate).format('YYYY-MM-DD'),
                amount: data.amount,
                description: data.description,
                user_id: userLogin.id,
            }),
            headers: new Headers({
                Authorization: `Bearer ${accesToken}`,
            }),
        }).then(response => response.json()).then(json => {
            setSaveLoading(false);

            if (json.status === 'ok') {
                alertService.success("Yeay, Perubahan berhasil disimpan.", options);
            } else {
                alertService.warning(json.message, options);
            }
        }).catch(error => {
            setSaveLoading(false);
        });
    };

    const onCallbackSelectOffer = useCallback((e) => {
        fetchDataOffer(e.id);
    }, []);

    return error404 ? <Error404 /> : (
        <>
            <Helmet>
                <title>Update Tagihan</title>
            </Helmet>
            <div className="d-block d-sm-none">
                <Navbar expand="lg" className="mainNavbar border-bottom mb-3" sticky="top">
                    <a href="#" onClick={() => navigate(-1)} className="navBackMenu">
                        <HiArrowLeft />
                    </a>
                    <strong className="me-auto navTitle">Update Tagihan</strong>
                    <Navbar.Toggle className="d-block d-sm-none me-3" onClick={(e) => setSidebarVisible(true)} />
                </Navbar>
            </div>
            <div className="d-none d-sm-inline">
                <Header />
            </div>
            <SidebarMenu show={sidebarVisible} close={(e) => setSidebarVisible(false)} />
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Container className="mt-3 mb-5">
                    <Row>
                        <Col md={7}>
                            <div className="d-none d-sm-inline">
                                <div className="mt-3 fw-bold">Update Tagihan</div>
                            </div>
                            <Row>
                                <Col>
                                    <BsAlert />
                                </Col>
                            </Row>
                            <Row className="mt-3 mb-3">
                                <Col md={10}>
                                    <Form.Label>Penawaran :</Form.Label>
                                    <InputGroup>
                                        <Controller
                                            render={({ field }) => (
                                                <Form.Control {...field}
                                                    type="number"
                                                    placeholder="Pilih penawaran"
                                                    readOnly
                                                    disabled
                                                    isInvalid={errors.offer_id ? true : false} />
                                            )}
                                            control={control}
                                            defaultValue={offer && offer.id}
                                            name="offer_id"
                                        />
                                        <Button variant="outline-secondary" onClick={(e) => setModalSelectOffer(true)}><FaSearch /> Cari</Button>
                                        <Link to="/penawaran/create" className="btn btn-outline-secondary"><FaPlus /> Tambahkan</Link>
                                    </InputGroup>
                                    <ModalSelectOffer onCallback={onCallbackSelectOffer} show={modalSelectOffer} close={(e) => setModalSelectOffer(false)} />
                                    <Form.Text className="text-muted fs-13 clearfix">{errors.offer_id?.message}</Form.Text>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Tanggal :</Form.Label>
                                        <Controller
                                            control={control}
                                            name="date"
                                            render={({ field }) => (
                                                <DatePicker
                                                    startDate={invoiceDate}
                                                    className={errors.date ? `is-invalid` : ``}
                                                    disabled={saveLoading}
                                                    isInvalid={errors.date ? true : false}
                                                    autoComplete="off"
                                                    onChange={(date) => {
                                                        setInvoiceDate(date);
                                                        field.onChange(date);

                                                    }}
                                                    selected={field.value}
                                                    customInput={<Form.Control />}
                                                />
                                            )}
                                        />
                                        <Form.Text className="text-muted fs-13 clearfix">{errors.date?.message}</Form.Text>
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Jatuh Tempo :</Form.Label>
                                        <Controller
                                            control={control}
                                            name="doeDate"
                                            render={({ field }) => (
                                                <DatePicker
                                                    startDate={doeDate}
                                                    minDate={invoiceDate}
                                                    className={errors.doeDate ? `is-invalid` : ``}
                                                    onChange={(date) => {
                                                        setDoeDate(date);
                                                        field.onChange(date);

                                                    }}
                                                    selected={field.value}
                                                    disabled={saveLoading}
                                                    isInvalid={errors.doeDate ? true : false}
                                                    autoComplete="off"
                                                    customInput={<Form.Control />}
                                                />
                                            )}
                                        />
                                        <Form.Text className="text-muted fs-13 clearfix">{errors.doeDate?.message}</Form.Text>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={8}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Tagihan Kepada :</Form.Label>
                                        <Controller
                                            control={control}
                                            name="customerName"
                                            disabled={saveLoading || isLoading}
                                            autoComplete="off"
                                            render={({ field }) => (
                                                <Form.Control type="text" isInvalid={errors.customerName} autoComplete="off" {...field} />
                                            )} />
                                        <Form.Text className="text-muted fs-13 clearfix">{errors.customerName?.message}</Form.Text>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Total Tagihan :</Form.Label>
                                        <Form.Control type="number" {...register("amount")} isInvalid={errors.amount ? true : false} disabled={saveLoading || isLoading} autoComplete="off" />
                                        <Form.Text className="text-muted fs-13 clearfix">{errors.amount?.message}</Form.Text>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Deskripsi :</Form.Label>
                                        <Form.Control type="text" as={'textarea'} rows={5}  {...register("description")} isInvalid={errors.description ? true : false} disabled={saveLoading} autoComplete="off" />
                                        <Form.Text className="text-muted fs-13 clearfix">{errors.description?.message}</Form.Text>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row className="mt-3">
                                <Col md={12} className="d-flex justify-content-end">
                                    <Link to={"/invoice"} title="Batal" className="btn btn-secondary me-3">Batal</Link>
                                    <Button type="submit" disabled={saveLoading}>{saveLoading ? "Mengirim data..." : "Simpan Perubahan"}</Button>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={5}>
                            <div className="mt-5 fw-bold">Penawaran</div>
                            <Table className="mt-2 fs-13">
                                <tbody>
                                    <tr>
                                        <td className="text-muted" width={120}>Penawaran ID</td>
                                        <td className="text-center" width={20}>:</td>
                                        <td className="fw-medium">
                                            {isLoading ?
                                                <div className="loader-text">
                                                    <Loader type="bubble-scale" bgColor={"#42A5F5"} size={25} />
                                                </div> :
                                                offer.id
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted" width={120}>Tanggal dibuat</td>
                                        <td className="text-center" width={20}>:</td>
                                        <td className="fw-medium">
                                            {isLoading ?
                                                <div className="loader-text">
                                                    <Loader type="bubble-scale" bgColor={"#42A5F5"} size={25} />
                                                </div> : params.invoice_id !== undefined &&
                                                <>
                                                    <strong><Moment format="D MMM YYYY">{offer.createdAt}</Moment></strong>
                                                    <span className="text-muted fw-medium"><Moment format=" - HH:mm A">{offer.createdAt}</Moment></span>
                                                </>
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted">Nama</td>
                                        <td className="text-center">:</td>
                                        <td className="fw-bold">
                                            {isLoading ?
                                                <div className="loader-text">
                                                    <Loader type="bubble-scale" bgColor={"#42A5F5"} size={25} />
                                                </div> :
                                                offer.customerName
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted">Email</td>
                                        <td className="text-center">:</td>
                                        <td className="fw-medium">
                                            {isLoading ?
                                                <div className="loader-text">
                                                    <Loader type="bubble-scale" bgColor={"#42A5F5"} size={25} />
                                                </div> :
                                                offer.customerEmail
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted">No Handphone</td>
                                        <td className="text-center">:</td>
                                        <td className="fw-medium">
                                            {isLoading ?
                                                <div className="loader-text">
                                                    <Loader type="bubble-scale" bgColor={"#42A5F5"} size={25} />
                                                </div> :
                                                offer.customerPhone
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted">Alamat</td>
                                        <td className="text-center">:</td>
                                        <td className="fw-medium">
                                            {isLoading ?
                                                <div className="loader-text">
                                                    <Loader type="bubble-scale" bgColor={"#42A5F5"} size={25} />
                                                </div> :
                                                offer.customerAddress
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted" width={150}>Deskripsi</td>
                                        <td className="text-center" width={20}>:</td>
                                        <td className="fw-medium">
                                            {isLoading ?
                                                <div className="loader-text">
                                                    <Loader type="bubble-scale" bgColor={"#42A5F5"} size={25} />
                                                </div> :
                                                offer.description
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted">Harga</td>
                                        <td className="text-center">:</td>
                                        <td className="fw-bold">
                                            {isLoading ?
                                                <div className="loader-text">
                                                    <Loader type="bubble-scale" bgColor={"#42A5F5"} size={25} />
                                                </div> :
                                                <NumericFormat
                                                    value={offer.price}
                                                    displayType={'text'}
                                                    thousandSeparator={true}
                                                    prefix={'Rp'}
                                                    renderText={(value, props) => <span {...props}>{value}</span>} />
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td className="text-muted">Target Inspeksi</td>
                                        <td className="text-center">:</td>
                                        <td className="fw-medium">
                                            {isLoading ?
                                                <div className="loader-text">
                                                    <Loader type="bubble-scale" bgColor={"#42A5F5"} size={25} />
                                                </div> : offer.items &&
                                                <NumericFormat
                                                    value={offer.items && offer.items.length}
                                                    displayType={'text'}
                                                    thousandSeparator={true}
                                                    prefix={''}
                                                    renderText={(value, props) => <span {...props}>{value} Mobil</span>} />
                                            }
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colSpan={3} className="border-0">
                                            {isLoading ?
                                                <Loader type="bubble-scale" bgColor={"#42A5F5"} size={25} /> :
                                                offer.items && offer.items.map((val, i) =>
                                                    <div className="py-2 px-3 shadow-sm mt-2 border rounded-3" key={`key${i}`}>
                                                        <div className="d-flex justify-content-between pb-2">
                                                            <div>
                                                                <Moment format="D MMM YYYY - HH:mm A">{offer.createdAt}</Moment> <br />
                                                                <strong>{val.policeNumber}</strong><br />
                                                                <span>{val.brandName}</span><br />
                                                                <span>{val.type}</span>
                                                            </div>
                                                            <div><BadgeStatus status={val.inspectionStatus} /></div>
                                                        </div>
                                                        <div className="d-flex border-top pt-2">
                                                            <span className="fst-italic">{val.location}</span>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        </td>
                                    </tr>
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </Container>
            </Form>
        </>
    );
}

export default UpdateInvoice;